<template>
  <UiModal layout="multi" :show="showNotic" :tabs="tabs" @close="close" />
</template>

<script setup>
import { ref } from 'vue'
import { useModal } from '@/composables/useModal'
import UiModal from '@/components/ui-modal.vue'
import PrizeAmount from './amount.vue'
import PrizeRule from './rule.vue'

const showNotic = ref(false)
const { close } = useModal('schedule-prize', showNotic)
const tabs = ref([
  { name: '奖金',     component: PrizeAmount, iconType: 'prize' },
  { name: '奖金规则', component: PrizeRule,   iconType: 'rule'  },
])
</script>
